export default __webpack_public_path__ + "assets/webgl/texture1.jpg.beb0fa1a.webp";